import { ITCFGatpVendor } from "types/tcf";
import type { ITCFConsent } from "../TCFConsentProvider/types";

const isTCFGatpVendorAccepted = (
  vendor: ITCFGatpVendor,
  consent: ITCFConsent,
): boolean => {
  return !!consent.gatp[vendor.provider_id];
};

export default isTCFGatpVendorAccepted;
